import { useUnit } from 'effector-react'
import { Spiner } from '../../spiner'
import { useStyles } from './styles'
import { $isUserGamedPremium } from '@/entities/user'
import { Icon } from '../../icon'

type StatisticsProps = {
  value: number | string | null
  name: string
  unit?: string
  difference?: number
  isLoading?: boolean
  isPremiumStat?: boolean
}

export const Statistics = (props: StatisticsProps) => {
  const { classes } = useStyles()
  const { value, name, difference, isLoading, isPremiumStat, unit } = props

  const isPlusUser = useUnit($isUserGamedPremium)
  const isLockedPremiumStat = isPremiumStat && !isPlusUser
  if (isLockedPremiumStat) {
    return (
      <div className={classes.rootWrapper}>
        <div className={classes.premiumLockerWrapper}>
          <Icon view="premiumStar" width={32} />
          <span className={classes.premiumText}>Premium</span>
        </div>
        <div className={classes.root} data-ispremium={isPremiumStat} data-islocked={isLockedPremiumStat}>
          <span className={classes.value} data-name={name}>
            {123}
          </span>
          <span className={classes.name}>Total hours played</span>
        </div>
      </div>
    )
  }

  return (
    <div className={classes.rootWrapper}>
      <div className={classes.root} data-ispremium={isPremiumStat} data-islocked={isLockedPremiumStat}>
        {isLoading ? (
          <Spiner variant="secondary" />
        ) : (
          <>
            <div className={classes.valueAndProgressWrapper}>
              <span className={classes.value} data-name={name}>
                {value} {unit}
              </span>
              <Progress difference={difference} />
            </div>
            <span className={classes.name}>{name}</span>
          </>
        )}
      </div>
    </div>
  )
}

const Progress = ({ difference = 0 }: { difference: number | undefined }) => {
  const { classes } = useStyles()
  const isPositive = difference && difference > 0

  if (difference === 0) return null
  return isPositive ? (
    <div className={classes.progressWrapper}>
      <span data-ispositive={isPositive}>+{difference}</span>
      <Icon view="progressUp" width={16} />
    </div>
  ) : (
    <div className={classes.progressWrapper}>
      <span data-ispositive={isPositive}>{difference}</span>
      <Icon view="progressDown" width={16} />
    </div>
  )
}
